import React, { useState } from 'react';
import { config } from '../../config';

export const Services = () => {
  const [showZoom, setShowZoom] = useState(false);

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-24">
          <p className="text-primary font-bold tracking-[0.3em] uppercase text-xs mb-6">Join Us</p>
          <h2 className="text-4xl sm:text-6xl font-bold mb-8">Worship With Us</h2>
          <p className="text-lg text-secondary/60 max-w-2xl mx-auto text-balance">
            Experience Spirit-led, Word-based, and life-transforming services at {config.church_name}.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto mb-32">
          {/* Sunday Service */}
          <div className="group relative p-10 rounded-[2.5rem] bg-accent border border-secondary/5 overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2">
            <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-bl-[5rem] transition-all duration-500 group-hover:w-40 group-hover:h-40"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-8 shadow-sm">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-3xl font-bold mb-4">Sunday Worship</h3>
              <div className="flex items-center gap-3 text-primary font-bold mb-6">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>{config.sunday_time}</span>
              </div>
              <p className="text-secondary/60 leading-relaxed">
                Experience uplifting worship, powerful teaching, and genuine fellowship in a welcoming environment.
              </p>
            </div>
          </div>

          {/* Midweek Service */}
          <div className="group relative p-10 rounded-[2.5rem] bg-secondary text-white overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-2">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-[5rem] transition-all duration-500 group-hover:w-40 group-hover:h-40"></div>
            <div className="relative z-10">
              <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-8 backdrop-blur-sm">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-3xl font-bold mb-4">Bible Study & Prayer</h3>
              
              <button 
                onClick={() => setShowZoom(!showZoom)}
                className="flex items-center gap-3 text-primary font-bold mb-6 hover:text-primary-light transition-colors focus:outline-none"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Wednesday – {config.wednesday_time}</span>
                <svg className={`w-4 h-4 transform transition-transform duration-300 ${showZoom ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {showZoom && (
                <div className="mb-6 p-6 bg-white/5 rounded-2xl border border-white/10 animate-fade-in">
                  <p className="text-primary font-bold text-sm mb-3 uppercase tracking-widest">Join via Zoom</p>
                  <div className="space-y-2 text-sm text-white/70">
                    <p><span className="text-white font-medium">Meeting ID:</span> 977 515 6154</p>
                    <p><span className="text-white font-medium">Passcode:</span> 940426</p>
                  </div>
                </div>
              )}

              <p className="text-white/60 leading-relaxed">
                Our messages are designed to bring you into full knowledge of our Lord and Saviour Jesus Christ.
              </p>
            </div>
          </div>
        </div>

        {/* What to Expect */}
        <div className="bg-accent rounded-[3rem] p-12 sm:p-20 relative overflow-hidden">
          <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="relative z-10">
            <h3 className="text-3xl sm:text-4xl font-bold mb-12 text-center">What to Expect</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12">
              {[
                { title: "Warm Welcome", desc: "A friendly greeting awaits you at our doors." },
                { title: "Uplifting Worship", desc: "Spirit-filled worship that touches the heart." },
                { title: "Bible Teaching", desc: "Practical, relevant messages from the scriptures." },
                { title: "Fellowship", desc: "Opportunities to connect and pray together." }
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mx-auto mb-6 shadow-sm">
                    <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h4 className="font-bold mb-2">{item.title}</h4>
                  <p className="text-sm text-secondary/60">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
